import { render, staticRenderFns } from "./TableSortWrapper.vue?vue&type=template&id=b218c33c&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b218c33c",
  null
  
)

export default component.exports